document.addEventListener("DOMContentLoaded", function () {
    var faqQuestions = document.querySelectorAll('.faq .faq-question');

    faqQuestions.forEach(function (question) {
        question.addEventListener('click', function () {
            var parent = this.parentNode;

            if (parent.classList.contains('faq-active')) {
                parent.classList.remove('faq-active');
            } else {
                // First, close all open answers
                document.querySelectorAll('.faq .faq-active').forEach(function (activeEl) {
                    activeEl.classList.remove('faq-active');
                });

                // Then, open the clicked one
                parent.classList.add('faq-active');
            }
        });
    });
});